import { useCallback, useState } from "react";
import { withLockGuard } from "web_myplann/Goals/Helpers/withLockGuard";
import type { PinStep } from "web_myplann/Goals/Types/PinStep";
import { GoalPortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const useGoalPinStep = (onLockedAction: (() => void) | null) => {
	const [pinStep, setPinStep] = useState<PinStep>("closed");
	const [pinPortfolioType, setPinPortfolioType] =
		useState<GoalPortfolioTypeEnum>(GoalPortfolioTypeEnum.Allocated);

	const openPin = useCallback((type: GoalPortfolioTypeEnum, step: PinStep) => {
		setPinPortfolioType(type);
		setPinStep(step);
	}, []);

	return {
		pinStep,
		pinPortfolioType,
		closePin: () => setPinStep("closed"),
		goToStep: setPinStep,
		openPin,
		openPinStep: withLockGuard(onLockedAction, (next: PinStep) => {
			if (next === "choose") {
				setPinPortfolioType(GoalPortfolioTypeEnum.Allocated);
			}
			setPinStep(next);
		}),
		openOwnFundsPin: withLockGuard(onLockedAction, () =>
			openPin(GoalPortfolioTypeEnum.SetAside, "choose"),
		),
	};
};
